import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { AccountsV3Service } from '../../../api/accountsV3-api/accountsV3-api.service'
import { MessageService } from '../../../components/message/message.service'
import { CommonModule } from '@angular/common'
import { FormInputService } from '../input-table/form-input.service'
import { FormInputInfo } from '../input-table/input-table.model'
import { InputTableComponent } from '../input-table/input-table.component'
import { SendingComponent } from '../../../components/sending/sending.component'
import { Router } from '@angular/router'
import { TitleComponent } from '../../../components/title/title.component'
import { ButtonSetting, IsIgxButtonComponent, IsIgxDialogMessageComponent } from '@interserve/igx-angular'
import { customerNameFormItem, mailAddressFormItem } from '../../../const/customer.const'
import { AccountwithCustomer, Customer, CustomerUi } from '../../../api/customers-api/customers-api.interface'
import { messageList } from '../../../components/message/message-data'
import { CustomerService } from '../../../api/customers-api/customers-api.service'
// import { IsBeAuthService } from '../../../components/isbeauth/isbeauth.service'
import { AuthService } from '../../../components/isbeauth/auth.service'
import { AccountInfo, BizTaskApiService } from '@interserve/angular'

@Component({
  selector: 'app-registration-account',
  templateUrl: './registration-account.component.html',
  styleUrls: ['./registration-account.component.scss'],
  imports: [
    CommonModule,
    SendingComponent,
    InputTableComponent,
    TitleComponent,
    IsIgxButtonComponent,
    IsIgxDialogMessageComponent,
  ],
})
export class RegistrationAccountComponent implements OnInit, AfterViewInit {
  @ViewChild('messageDialog', { static: true }) public messageDialog: IsIgxDialogMessageComponent | undefined
  @ViewChild(InputTableComponent, { static: false })
  private inputTable!: InputTableComponent
  title = 'アカウント登録'
  customerCd: string = ''

  formItems: FormInputInfo[] = []
  formValue: any = null
  sending = false

  registerButton: ButtonSetting = {
    key: 'select',
    label: '登録',
    color: 'primary',
    action: 'create',
  }
  account: AccountInfo | undefined = undefined

  constructor(
    private messageService: MessageService,
    // private accountsV3Service: AccountsV3Service,
    private formInputService: FormInputService,
    private customerService: CustomerService,
    private router: Router,
    private authService: AuthService, // private isAccountService: IsAccountService, // private isBeAuthService: IsBeAuthService
  ) {}

  ngOnInit(): void {
    const nickNameForm = this.formInputService.nickNameForm()
    nickNameForm.label = 'ニックネーム（ログインID）'
    const passwordForms = this.formInputService.changePasswordForm()
    passwordForms[0].label = 'パスワード'
    passwordForms[1].label = 'パスワード（確認用) '
    this.formItems = [nickNameForm, ...passwordForms, customerNameFormItem, mailAddressFormItem]

    this.account = this.authService.Account
  }

  ngAfterViewInit(): void {
    this.setFormDefaultValue()
  }

  setFormDefaultValue(): void {
    this.inputTable.setForm(this.formValue)
  }
  async submit(): Promise<void> {
    const submitForm = this.inputTable.submit()
    if (!submitForm) {
      return
    }
    // 自前でチェック
    if (submitForm.password !== submitForm.passwordConfirmation) {
      this.messageService.error('パスワードとパスワード（確認用）が一致しません')
      return
    }
    this.messageDialog?.open()
  }
  async dialogAction(value: any) {
    this.messageDialog?.close()
    if (value === 'save') {
      // ログインIDチェック
      if (this.sending) {
        return
      }
      this.sending = true
      const submitForm = this.inputTable.submit()
      this.formValue = submitForm

      let chkret = await this.customerService.NicknameSearch(this.formValue?.nickName)
      if (chkret.data === true) {
        this.sending = false
        this.messageService.error('このログインIDはすでに別のユーザーが使用しているため、設定できません')
        return
      }

      // 顧客登録
      const ret = await this.createCustomer()
      if (!ret) {
        this.messageService.templateMessage(messageList.M00001) //システムエラー
      } else {
        this.messageService.templateMessage(messageList.M00071) //アカウントを登録しました

        // this.router.navigate(['welcome']).then(() => {
        //   //自動ログイン
        //   this.isBeAuthService.onBeginLogin()
        // })
        this.authService.setLoginStatus(true)
        this.router.navigate(['welcome'])
      }

      this.sending = false
    }
  }
  async createCustomer() {
    const submitForm = this.inputTable.submit()
    const customerInfo: AccountwithCustomer = {
      customerCd: crypto.randomUUID(),
      familyName: submitForm.familyName,
      firstName: submitForm.firstName,
      firstNameKana: submitForm.firstNameKana,
      familyNameKana: submitForm.familyNameKana,
      mailAddress: submitForm.mailAddress,
      nickname: submitForm.nickName,
      password: submitForm.password,
    }

    const ret = await this.customerService.CreateAccountWithCustomer(customerInfo)
 

    if (ret?.resultCode !== 0) {
      this.sending = false
      return false
    }
    const customer = ret.data
    if (ret.data.accountId) {
      // 自動ログイン用
      this.authService.setAutoLoginAccountId(ret.data.accountId)
    }
    return true
  }
}
